import { NavRouteConfig } from './types';

class NavRoutesRegister {
  private static instance: NavRoutesRegister;

  private registry: NavRouteConfig[];

  private constructor() {}

  public static readonly InvalidateEvent = 'invalidateRoutes';

  public register(routes: NavRouteConfig[]): void {
    this.registry = routes;
  }

  public getAll(): NavRouteConfig[] {
    return this.registry;
  }

  /**
   * Forces rerendering of the side navigation in client-app.
   */
  public invalidate(): void {
    window.dispatchEvent(new Event(NavRoutesRegister.InvalidateEvent));
  }

  public static getInstance(): NavRoutesRegister {
    if (!NavRoutesRegister.instance) {
      NavRoutesRegister.instance = new NavRoutesRegister();
    }
    return NavRoutesRegister.instance;
  }

  public static reset() {
    NavRoutesRegister.instance = undefined;
  }
}

export { NavRoutesRegister };
